import React from 'react';
import { MapPin } from 'lucide-react';
import styles from './LoadingScreen.module.css';

const LoadingScreen = ({ businessLoading }) => {
    return (
        <div className={`${styles.container} dark:bg-gradient-to-b dark:from-gray-900 dark:to-gray-800`}>
            <div className={styles.iconWrapper}>
                <MapPin size={48} className="text-white dark:text-gray-200" />
            </div>
            <div className={`${styles.text} dark:text-gray-200`}>
                Loading...
            </div>
            <div className={`${styles.spinner} dark:border-gray-200 dark:border-t-transparent`}></div>
        </div>
    );
};

export default LoadingScreen;
